import { BASE_URL } from '@/config/api';

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  Authorization: `Bearer ${localStorage.getItem('auth-token') || ''}`,
});

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const res = await fetch(`${BASE_URL}/api${path}`, { headers: authHeaders(), ...options });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as any)?.message || 'Request failed');
  return data as T;
}

export interface TwoFactorStatus {
  enabled: boolean;
  confirmed_at?: string | null;
}

export interface TwoFactorSetup {
  secret: string;
  otpauth_url: string;
  issuer?: string;
  account?: string;
}

export const getTwoFactorStatus = () => request<TwoFactorStatus>('/two-factor/status');

export const startTwoFactorSetup = () =>
  request<TwoFactorSetup>('/two-factor/setup', { method: 'POST' });

export const confirmTwoFactor = (code: string) =>
  request<{ enabled: boolean; recovery_codes?: string[] }>('/two-factor/confirm', {
    method: 'POST',
    body: JSON.stringify({ code }),
  });

export const disableTwoFactor = (payload: { code?: string; password?: string }) =>
  request<{ enabled: boolean }>('/two-factor/disable', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
